import React from 'react'

export const enUs = {
    values: {
        'Error loading algorithms configs': 'Error loading algorithms configs.',
        'Settings saved successfully.': 'Settings saved successfully.',
        error_saving_settings: 'Error occurred while saving settings',
        'GENERAL OPTIONS': 'GENERAL OPTIONS',
        'Rig State auto detection': 'Rig State auto detection',
        Unavailability: 'Unavailability',
        'Set status to': 'Set status to',
        after: 'after',
        'of missing data': 'of missing data',
        'ALGORITHM OPTIONS': 'ALGORITHM OPTIONS',
        or: 'or',
        cancel: 'cancel',
        'Default rig state name': 'Default rig state name',
        'Default color': 'Default color',
        'New rig state name (optional)': 'New rig state name (optional)',
        'New color - RGB or HEXA (optional)': 'New color - RGB or HEXA (optional)',
        Parameter: 'Parameter',
        'Input and output': 'Output',
        'Advanced parameters': 'Advanced parameters',
        'How to use': 'How to use',
        'Info Query': 'The following query will work with the Rig State Chart (inside the Standard Chart options)',
        Copy: 'Copy',
        'Output Rig States': 'Output Rig States',
        _preset_rename_message_: ({ oldName, newName }) => {
            return `The preset "${oldName}" has been successfully renamed to  "${newName}"`
        },
        _preset_create_message_: ({ name }) => {
            return `The preset "${name}" has been successfully created.`
        },
        _preset_activate_message_: ({ name }) => {
            return `The preset "${name}" has been successfully activated.`
        },
        _preset_delete_message_: ({ name }) => {
            return `The preset "${name}" has been deleted successfully.`
        },
        _preset_save_message_: ({ name }) => {
            return `The changes to the parameters of preset "${name}" have been saved successfully.`
        },
        _preset_ative_warn: ({ oldPreset, newPreset }) => {
            return `If you activate the preset "${newPreset}", the current active preset "${oldPreset}" will be deactivated.`
        },
        _dismiss_all_: () => {
            return (
                <>
                    Values in <span>red</span> have been updated in the Rig State settings. To use an updated default
                    value, leave the specified value field empty.
                </>
            )
        },

        _change_config_unit_: ({ oldUnit, newUnit }) => {
            return (
                <p>
                    The parameter units have been updated from{' '}
                    <b>
                        "{oldUnit}
                        -based"
                    </b>{' '}
                    to <b>"{newUnit}-based"</b>. All the default and specified values using old units have been
                    converted.
                </p>
            )
        },
        rig_state_model_description: () => (
            <span>
                Newer version of Intelie Rig State Detection algorithm. This is the algorithm that Intelie Live will use
                for its built-in features.
                <b> It’s also accessible through Pipes functions.</b>
            </span>
        ),
        rig_state_legacy_description: () => (
            <span>
                Older version of Intelie Rig State Detection algorithm.
                <b> It’s accessible only through Pipes functions.</b>
            </span>
        ),
        rig_state_simplified_description: () => (
            <span>
                Simplified version of Intelie Rig State Detection algorithm.
                <b> It’s accessible only through Pipes functions.</b>
            </span>
        ),
        'Hole Section': 'Hole Section',
        'Macro Rig State': 'Macro Rig State',
        'Well name is a required field.': 'Well name is a required field.',
        'Rig name is a required field.': 'Rig name is a required field.',
        channels_id_hint: ({ isAdmin }) => (
            <div>
                This feature depends on the{' '}
                {isAdmin ? (
                    <a href="/#/config/standard-channels">Channels Identification</a>
                ) : (
                    <strong>Channels Identification</strong>
                )}{' '}
                to work properly. Some of your channels are not identified yet.
            </div>
        ),
        'Start time is a required field': 'Start time is a required field',
        'ADD RIG STATE': 'ADD',
        'Intelie Rig State Detection Legacy': 'Intelie Rig State Legacy',
        when_enabled:
            'When enabled, it will generate an event for each detected rig state and also display it on the rig and well interfaces.',
        here_overrite: 'Here you can override the Default rig state names given by the selected algorithm. (optional)'
    }
}
